<template>
        <flickity class="flickity" :ref="myRef" :options="options" v-images-loaded:on.progress="layout">
            <slot></slot>
        </flickity>
    </div>
</template>

<script>
  import Flickity from 'vue-flickity';
  import imagesLoaded from 'vue-images-loaded';

  export default {
    name: 'flickity-box',
    directives: {
      imagesLoaded,
    },

    components: {
      Flickity,
    },

    props: [
      'my-ref',
      'options',
    ],

    data() {
      return {
        reloaded: false,
      };
    },

    methods: {
      reload() {
        this.$children[0].resize();
      },
      layout(e) {
        if (e.isComplete && !this.reloaded) {
          this.reloaded = true;
          this.reload();
        }
      },
    },
  };
</script>
<style lang="scss">
    .flickity {
        .flickity-viewport {
            margin-left: 25px;
            margin-right: 25px;
            margin-bottom: 25px;
        }

        .flickity-prev-next-button.previous {
            left: -10px;
        }
        .flickity-prev-next-button.next {
            right: -10px;
        }

        .flickity-prev-next-button {
            width: 30px;
            height: 30px;
        }

        .carousel-cell {
            display: flex;
            align-items: stretch;
            @media screen and (max-width:768px){
                flex-direction: column;
            }

            img {margin:auto;}

        }
        .carousel-cell > div{
            flex: 1;
        }

        .desc {
            text-align: left;
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/FlickityBox.vue